import { z } from 'zod';

const generateGrammarAudioV1RequestSchemaDefinition = z.object({
  cursor: z.number().int().min(0).optional(),
  limit: z.number().int().min(1).max(20).optional(),
});

export const generateGrammarAudioV1RequestSchema: typeof generateGrammarAudioV1RequestSchemaDefinition =
  generateGrammarAudioV1RequestSchemaDefinition;

export type IGenerateGrammarAudioV1Request = z.infer<typeof generateGrammarAudioV1RequestSchema>;
